export const AUTH_REQUEST = "AUTH_REQUEST";
export const AUTH_SUCCESS = "AUTH_SUCCESS";
export const AUTH_ERROR = "AUTH_ERROR";
export const AUTH_LOGOUT = "AUTH_LOGOUT";
export const AUTH_RESTAPI = "AUTH_RESTAPI";
export const AUTH_INITIALIZE = "AUTH_INITIALIZE";



// WEBPACK FOOTER //
// ./src/store/actions/auth.js